"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var _default = {
  allowedTags: _sanitizeHtml.default.defaults.allowedTags.concat(['video', 'table', 'dt', 'q', 'abbr', 'em', 'samp', 'acronym', 'font', 'small', 'address', 'h1', 'span', 'b', 'h2', 'strike', 'bdo', 'h3', 'strong', 'big', 'h4', 'sub', 'blockquote', 'h5', 'sup', 'br', 'h6', 'caption', 'hr', 'tbody', 'cite', 'i', 'td', 'code', 'img', 'tfoot', 'col', 'ins', 'th', 'colgroup', 'kbd', 'thead', 'dd', 'li', 'tr', 'del', 'ol', 'tt', 'dfn', 'p', 'ul', 'div', 'pre', 'var', 'dl', 'iframe', 'a', 'area', 'article', 'aside', 'audio', 'bdi', 'center', 'details', 'figcaption', 'figure', 'footer', 'header', 'mark', 'nav', 's', 'section', 'summary', 'u', 'accordion-block', 'table-list']),
  allowedAttributes: _objectSpread(_objectSpread({}, _sanitizeHtml.default.defaults.allowedAttributes), {}, {
    '*': ['alt', 'face', 'size', 'background', 'height', 'src', 'border', 'href', 'style', 'class', 'name', 'target', 'colspan', 'rowspan', 'width', 'start', 'title', 'shape', 'coords', 'autoplay', 'controls', 'crossorigin', 'loop', 'muted', 'preload', 'dir', 'cite', 'align', 'valign', 'span', 'datetime', 'open', 'color', 'playsinline', 'poster', 'data-list', 'data-button-json', 'data-json', 'expand', 'tracking', 'data-type', 'data-params', 'is-ui-optimisation-accordion', 'default-select-index', 'index']
  }),
  allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel', 'custom-data', 'in-app', 'intent', 'form-url']
};
exports.default = _default;